import { useTranslation } from 'react-i18next';
import useSWR from 'swr';

import { Card, TwoLineGrid } from '~components';
import { getKeyTypeLabel } from '~enums/keyTypeEnum';
import { getService } from '~services/serviceFactory';
import { defaultPlaceholder, ifNullOrEmpty } from '~utils/stringUtils';

import KeysService from '../../services/keysService';

const keysService = getService(KeysService);

/**
 * Todo: This whole component needs loading and error states
 */
interface KeyInformationCardProps {
	keyId: string;
	organisationId?: string | undefined;
}

const KeyInformationCard = ({ keyId, organisationId }: KeyInformationCardProps) => {
	const { t } = useTranslation();

	const {
		data: keyData,
		error: keyError,
		isLoading: keyIsLoading,
	} = useSWR(
		keysService.getKeyByIdCacheKey(keyId, organisationId),
		([_, id, orgId]) => (id ? keysService.getKeyById(id, orgId ?? undefined) : null),
		{
			revalidateOnMount: true,
		}
	);

	const isInitialLoading = keyIsLoading && keyData == undefined;
	const hasError = keyError != undefined;

	const keyType = keyData?.type;
	const keyTypeLabel = keyType ? getKeyTypeLabel(keyType, t) : defaultPlaceholder;

	return (
		<Card title={t('key.fields.generalInformation', { ns: 'entities' })} sx={{ height: '100%' }}>
			<TwoLineGrid
				isLoading={isInitialLoading}
				showError={hasError}
				twoLineItems={[
					{
						primary: t('general.name', { ns: 'entities' }),
						secondary: ifNullOrEmpty(keyData?.name),
					},
					{
						primary: t('key.fields.idToken', { ns: 'entities' }),
						secondary: ifNullOrEmpty(keyData?.idToken),
					},
					{
						primary: t('key.fields.serialNumber', { ns: 'entities' }),
						secondary: ifNullOrEmpty(keyData?.serialNumber),
					},
					{
						primary: t('general.type', { ns: 'entities' }),
						secondary: keyTypeLabel,
					},
					{
						primary: t('key.fields.description', { ns: 'entities' }),
						secondary: ifNullOrEmpty(keyData?.description, t('noDescription', { ns: 'status' })),
					},
				]}
			/>
		</Card>
	);
};

export default KeyInformationCard;
